"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESignType = void 0;
var ESignType;
(function (ESignType) {
    ESignType["CLIENT"] = "CLIENT";
    ESignType["CC_AGENT"] = "CC_AGENT";
})(ESignType || (exports.ESignType = ESignType = {}));
//# sourceMappingURL=index.js.map